import { render } from "./SimpleCountdown.vue?vue&type=template&id=080e7836&scoped=true"
import script from "./SimpleCountdown.vue?vue&type=script&lang=js"
export * from "./SimpleCountdown.vue?vue&type=script&lang=js"

import "./SimpleCountdown.vue?vue&type=style&index=0&id=080e7836&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-080e7836"]])

export default __exports__